












import {Component, Vue, Watch} from 'vue-property-decorator';
import * as auth from "@/store/authenticate";
import LayoutDefault from '../../layout/default.vue';


@Component({
    components: {

    },
    name: 'Dashboard',
})
export default class Dashboard extends Vue{


}
